import { render } from "./AddSliderTestimoniHome.vue?vue&type=template&id=5cb636f4&scoped=true"
import script from "./AddSliderTestimoniHome.vue?vue&type=script&lang=js"
export * from "./AddSliderTestimoniHome.vue?vue&type=script&lang=js"

import "./AddSliderTestimoniHome.vue?vue&type=style&index=0&id=5cb636f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb636f4"]])

export default __exports__